import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Ensures every route change starts at the top of the page.
 * Mount once inside the Router.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
